import { IState } from "./types";

export const state: IState = {
    scrollPosition: 0,
    albums: [],
    store: [],
    mediasToShow: [],
    currentMediaIndex: 0,
    hasError: false,
    errorMessage: undefined,
    isAjaxRun: false,
    isGalleryOpen: false,
    openingHours: [],
    addresses: []
};
